/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var DemoStatus;

(function (DemoStatus) {
  DemoStatus["BOOKED"] = "booked";
  DemoStatus["ATTENDED"] = "attended";
  DemoStatus["NO_SHOW"] = "no_show";
  DemoStatus["RESCHEDULED"] = "rescheduled";
  DemoStatus["CANCELLED_BY_CONTACT"] = "cancelled_by_contact";
  DemoStatus["CANCELLED_INTERNALLY"] = "cancelled_internally";
})(DemoStatus || (DemoStatus = {}));